const state = {
  reviewsAnswerId: null,
  preguntas: [],
  tiempoDisponible: 0,
  dateCreation: null,
  resultado: null,
  cargando: false
}

export default state
